import React from 'react'

import styles from 'components/pages/support/help/helpStyles'
import { HelpComponentProps } from 'types/Help'
import { useFormatMessage } from 'lib/localization'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const BASE_I18N_KEY = 'ess.help_self_service_2'

function SelfService2I18n({ classes, productName }: { classes: ReturnType<typeof styles>; productName?: string }) {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  return (
    <div className={classes.content} data-testid="content">
      {formatMessage('content')}
      <p>{formatMessage('mx_prepopulate', { productName })}</p>
      {formatMessage('test_instruction')}
      <p>{formatMessage('skip_instruction')}</p>
    </div>
  )
}

function SelfService2(props: HelpComponentProps) {
  const classes = styles()
  let isSmartlingEnabled = false
  try {
    isSmartlingEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    // Default to OFF when called outside Redux context
  }

  if (isSmartlingEnabled) {
    return <SelfService2I18n classes={classes} productName={props.productName} />
  }

  // Flag OFF: Original hardcoded English content
  return (
    <div className={classes.content} data-testid="content">
      Enter your mail server IP address or hostname (FQDN) and click <b>Add</b>.
      <p>
        If {props.productName} Setup wizard has already identified your mail server IP based on the MX record, it will
        prepopulate the <b>Mail Servers</b>.
      </p>
      Before proceeding to the next step, ensure that all the mail servers you&apos;re using can verify the test email
      address. After entering a valid email address for your domain, click <b>Test All Mail Servers</b>.
      <p>
        To skip this step and enter your mail server information later on the <b>DOMAINS &gt; Domains Manager</b> page,
        click the <b>Skip</b> button.
      </p>
    </div>
  )
}

export default SelfService2
